<ng-template #template>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title i18n>Audit</mat-panel-title>
        </mat-expansion-panel-header>
        <app-audit [item]="item"> </app-audit>
        <mat-action-row>
            <button type="button" mat-flat-button color="accent" (click)="back.emit()" i18n>Close</button>
            <span flex></span>
        </mat-action-row>
    </mat-expansion-panel>
</ng-template>